module.exports = __webpack_public_path__ + "static/media/atom.32feae51.svg";